import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { CubeStatus } from 'Cube/domain/cube.domain.types'
import { useOtherQuoteLabel } from 'Cube/view/layouts/quote/hooks/useOtherQuoteLabel'

type UseAmendmentOutForSignatureBanner = () => {
  isVisible: boolean
  outForSignatureQuote: {
    id: string
    label: string
  }
}

/**
 * Names the other amendment of this schedule that is out for signature or signed, so it's clear
 * why this one can't be sent for signature or marked as signed yet. A superseded amendment has its
 * own banner, which says more, and an executed or archived one has nothing left to sign.
 */
export const useAmendmentOutForSignatureBanner: UseAmendmentOutForSignatureBanner =
  () => {
    const ctx = useCubeContext()
    const { common, quote } = ctx.queries.rawData.data
    const outForSignatureQuoteId =
      quote.dealType === 'AMENDMENT'
        ? quote.amendment?.outForSignatureQuoteId
        : undefined

    const isStillOpen =
      !common.isArchived &&
      common.status !== CubeStatus.QuoteExecuted &&
      !quote.amendment?.supersededByQuoteId

    const label = useOtherQuoteLabel({ quoteId: outForSignatureQuoteId })

    return {
      isVisible: Boolean(outForSignatureQuoteId) && isStillOpen,
      outForSignatureQuote: {
        id: outForSignatureQuoteId ?? '',
        label
      }
    }
  }
